import * as React from "react";
import { useState } from "react";
import CsvTable from "@imminently/decisively-ui/CsvTable";
import DataTable, { type DataTableColumn } from "@imminently/decisively-ui/DataTable";
import Switch from "@imminently/decisively-ui/Switch";

import { ComponentPage, ComponentPreview, ComponentSection, ControlPanel, ControlRow } from "../components/ComponentPage";

const employees = [
  { id: 1, employeeId: "EMP0001", name: "Jane Smith", email: "jane.smith@example.com", team: "Payroll" },
  { id: 2, employeeId: "EMP0002", name: "Jack Brown", email: "123", team: "Operations" },
  { id: 3, employeeId: "", name: "Alex Lee", email: "alex.lee@example.com", team: "Payroll" },
  { id: 4, employeeId: "EMP0004", name: "Sam Taylor", email: "sam.taylor@example.com", team: "Finance" },
];

const dataTableColumns: DataTableColumn[] = [
  { field: "employeeId", headerName: "Employee ID", width: 160 },
  { field: "name", headerName: "Name", flex: 1, minWidth: 160 },
  { field: "email", headerName: "Email", flex: 1, minWidth: 200 },
  { field: "team", headerName: "Team", width: 160 },
];

const csvHeaders = ["EmployeeID", "Name", "Email", "Team"];
const csvRows = employees.map(({ employeeId, name, email, team }) => [employeeId, name, email, team]);
const csvRowErrors = [undefined, "row 3: Email must be a valid email address", "row 4: EmployeeID is required", undefined];

export function TablesPage() {
  const [withRowErrors, setWithRowErrors] = useState(true);
  const [selectableRows, setSelectableRows] = useState(true);

  return (
    <ComponentPage
      title="Tables"
      description="DataTable for records the app manages, and CsvTable for previewing CSV files. CsvTable is built on DataTable."
    >
      <ComponentSection
        title="DataTable"
        description="MUI's data grid with our styling: sorting, column menus, pagination and selection."
      >
        <ComponentPreview className="items-stretch justify-stretch p-4">
          <div className="h-[320px] w-full">
            <DataTable
              columns={dataTableColumns}
              rows={employees}
              hideFooter
            />
          </div>
        </ComponentPreview>
      </ComponentSection>

      <ComponentSection
        title="CsvTable"
        description="A read-only preview of CSV rows. rowErrors adds an Error column first, with an icon giving each failed row's reason on hover. selectableRows highlights a row when it's clicked."
      >
        <div className="grid gap-6 lg:grid-cols-[1fr_280px]">
          <ComponentPreview className="items-stretch justify-stretch p-4">
            <div className="h-[320px] w-full">
              <CsvTable
                ariaLabel="Employee CSV preview"
                headers={csvHeaders}
                rows={csvRows}
                rowErrors={withRowErrors ? csvRowErrors : undefined}
                selectableRows={selectableRows}
              />
            </div>
          </ComponentPreview>

          <ControlPanel>
            <ControlRow label="Row errors">
              <Switch
                checked={withRowErrors}
                onCheckedChange={setWithRowErrors}
              />
            </ControlRow>
            <ControlRow label="Selectable rows">
              <Switch
                checked={selectableRows}
                onCheckedChange={setSelectableRows}
              />
            </ControlRow>
          </ControlPanel>
        </div>
      </ComponentSection>
    </ComponentPage>
  );
}
